import { chatHcpFullAccessPolicy } from './chat-hcp-full-access.js';
import { chatMessagingPolicy } from './chat-messaging.js';
import { dataScientistPolicy } from './data-scientist.js';
import { debuggerPolicy } from './debugger.js';
import { endUserRole } from './end-user-role.js';
import { insightEdgeAdminRole, insightEdgeViewerRole } from './insightedge-roles.js';
import { INSIGHTEDGE_POLICIES } from './insightedge.js';
import { managementAppAdminPolicy } from './management-app-admin.js';
import { managementAppReadOnlyPolicy } from './management-app-read-only.js';
import { nationalUserRole } from './national-user-role.js';
import type { BuiltinPolicyDefinition, BuiltinRoleDefinition } from './types.js';

export * from './types.js';
export {
  chatHcpFullAccessPolicy,
  chatMessagingPolicy,
  dataScientistPolicy,
  debuggerPolicy,
  endUserRole,
  insightEdgeAdminRole,
  INSIGHTEDGE_POLICIES,
  insightEdgeViewerRole,
  managementAppAdminPolicy,
  managementAppReadOnlyPolicy,
  nationalUserRole,
};

/** Source of truth for built-in policies. Sync to the database with `pnpm --filter @trinity/access-policy builtin-policies-migration`. */
export const BUILTIN_POLICIES: readonly BuiltinPolicyDefinition[] = [
  managementAppAdminPolicy,
  dataScientistPolicy,
  managementAppReadOnlyPolicy,
  chatHcpFullAccessPolicy,
  chatMessagingPolicy,
  debuggerPolicy,
  ...INSIGHTEDGE_POLICIES,
];

/** Source of truth for built-in roles. Synced to the database by the same migration generator as the built-in policies. */
export const BUILTIN_ROLES: readonly BuiltinRoleDefinition[] = [
  endUserRole,
  nationalUserRole,
  insightEdgeViewerRole,
  insightEdgeAdminRole,
];
